<!--
Mensagem modal de limite do plano
-->

<script type="text/babel">
import { SysVars } from '../main'

export default {
    data () {
      return {
      }
    },
    computed: {
      mensagemAdicioneUsuarios: function () {
        if (SysVars.limiteUsuariosAlcancado && SysVars.appForcaVendas)
          return true
        else
          return false
      },
      mensagem: function () {
        return SysVars.limitePlanoMensagem
      },
    },
    created () {
      this.$router.push('/minhaconta')
    },
    mounted (){

    },
    methods: {
      handleCloseButton () {
        SysVars.showLimitePlano = false
        SysVars.limiteUsuariosAlcancado = false
      },

      async handleMinhaConta () {
        SysVars.showLimitePlano = false
        SysVars.limiteUsuariosAlcancado = false
      }
    }
}
</script>

<template>
  <transition>
    <div class="modal nb-modal-mask" style="display: block">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document" style="overflow-y: initial !important">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="def-title" id="exampleModalLabel"> Limite de Plano Atingido </h4>
            <button type="button" class="close" @click="handleCloseButton()" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="max-height: 255px; overflow-y: auto">
            <div class="col-12 mt-3 mb-3">
              <span class=""> O limite do plano foi alcançado para esta funcionalidade! </span>
            </div>
            <div class="col-12 mb-3" v-if="mensagemAdicioneUsuarios">
              <span class=""> Acrescente mais usuários ou faça o upgrade de plano para acrescentar mais usuários e mais recursos! </span>
            </div>
            <div class="col-12 mb-3" v-else>
              <span class=""> Efetue a agora mesmo o upgrade de plano para acrescentar mais recursos! </span>
            </div>
            <div class="col-12 mb-3" v-if="mensagem">
              <span class=""> {{ mensagem }} </span>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-sm btn-warning" @click="handleMinhaConta"> Ver Meu Plano </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<style>
</style>



// WEBPACK FOOTER //
// src/components/md-limite-plano.vue